import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { differenceInDays } from 'date-fns';
import { EnvironmentService } from 'src/app/snatch/services';

@Component({
  selector: 'leap-expiring-contract-alert',
  templateUrl: './expiring-contract-alert.component.html',
  styleUrls: ['./expiring-contract-alert.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpiringContractAlertComponent implements OnInit {

  @Input() templateId: string;
  @Input() expiryDate: number;
  daysLeft: number;
  constructor(private environment: EnvironmentService) { }

  ngOnInit() {
    this.daysLeft = differenceInDays(
      new Date(this.expiryDate * 1000),
      new Date()
    )
  }

  renew() {
    const url = `${this.environment.saharaUrl}/contracts/buyer/renew/${this.templateId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

}
